import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
    HotelResultsComponent,
    HotelVoucherComponent,
    HotelCancellationComponent
} from './components';
import { HotelConfirmationComponent } from './components/hotel-booking/components/hotel-confirmation/hotel-confirmation.component';
import { HotelGuestDetailsComponent } from './components/hotel-booking/components/hotel-guest-details/hotel-guest-details.component';
import { HotelPaymentDetailComponent } from './components/hotel-booking/components/hotel-payment-detail/hotel-payment-detail.component';
import { HotelBookingComponent } from './components/hotel-booking/hotel-booking.component';
import { HotelSearchComponent } from './components/hotel-search/hotel-search.component';
import { HotelPaymentStatusComponent } from './components/hotel-booking/components/hotel-payment-detail/hotel-payment-status/hotel-payment-status.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                component: HotelSearchComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-results',
                component: HotelResultsComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-booking',
                component: HotelBookingComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-guests',
                component: HotelGuestDetailsComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-payment',
                component: HotelPaymentDetailComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-voucher',
                component: HotelVoucherComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-confirmation',
                component: HotelConfirmationComponent,
                data: { extraParameter: 'searchMenus' }
            },
            {
                path: 'hotel-payment-status',
                component: HotelPaymentStatusComponent,
                data: { extraParameter: 'searchMenus' }
            },
            {
                path: 'hotel-search',
                component: HotelSearchComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'hotel-cancellation',
                component: HotelCancellationComponent,
                data: { extraParameters: '' }
            }
        ]
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HotelRoutingModule { }
